<div *ngIf="productSidebarOpened$ | async" class="feedback-container cf-flex cf-flex-column cf-gap-8">
  <ng-container *ngIf="feedbackMessages$ | async as messages">
    <div *ngIf="messages.length === 0" class="ac-message info cf-flex cf-flex-row cf-gap-8 cf-align-items-center">
      <span class="icon-container"><mat-icon class="ac-message-icon info" svgIcon="info"></mat-icon></span>
      {{ 'UI.Product.ConfigurationValid' | translate }}
    </div>

    <div *ngFor="let message of messages">
      <app-product-message-link
        [parentEntity]="message.Parent"
        [level]="message.Properties['Level'].Value"
        [isPrice]="isPriceDialogMessage(message, hoodEntityType$ | async)"
        [matTooltip]="getPropertyName(message, propertyTypes$ | async)"
      >
        <app-message-icon [messageLevel]="message.Properties['Level'].Value"></app-message-icon>
        <span
          class="mat-body-2 message-text"
          [ngClass]="{
            error: message.Properties['Level'].Value === 0,
            warning: message.Properties['Level'].Value === 1,
            info: message.Properties['Level'].Value === 2
          }"
        >
          {{ getMessageTargetCode(message, hoodTypeKeys$ | async) }}:
          {{ message.Properties['Text'].Value || (message.Properties['TextId'].Value | translate) }}
        </span>
      </app-product-message-link>
    </div>
  </ng-container>

  <ng-container *ngIf="notes$ | async as notes">
    <div *ngFor="let note of notes">
      <app-product-message-link [parentEntity]="note.entity" [level]="2">
        <app-message-icon [messageLevel]="2"></app-message-icon>
        <span class="mat-body-2 message-text info">
          {{ getMessageTargetCode(note.entity, hoodTypeKeys$ | async) }}:
          {{ note.property.Value }}
        </span>
      </app-product-message-link>
    </div>
  </ng-container>
</div>
